<template>
  <nav v-if="items.length > 0" class="flex my-2">
    <ol
      class="inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse"
    >
      <li
        v-for="(item, index) in items"
        :key="index"
        class="inline-flex items-center"
      >
        <template v-if="index === 0">
          <component
            :is="item.href ? 'a' : 'span'"
            :href="item.href"
            :class="[
              'inline-flex items-center text-sm font-medium',
              item.href || item.onClick || item.routeName
                ? 'text-gray-700 hover:text-blue-600 cursor-pointer'
                : 'text-gray-500 cursor-default',
            ]"
            @click="item.href ? null : handleClick(item, index)"
          >
            <Home class="w-4 h-4 me-2.5" />
            {{ item.label }}
          </component>
        </template>
        <template v-else>
          <div class="flex items-center">
            <ChevronRight class="rtl:rotate-180 w-3 h-3 text-gray-400 mx-1" />
            <component
              :is="item.href ? 'a' : 'span'"
              :href="item.href"
              :class="[
                'ms-1 text-sm font-medium md:ms-2',
                index === items.length - 1
                  ? 'text-gray-500 cursor-default'
                  : item.href || item.onClick || item.routeName
                    ? 'text-gray-700 hover:text-blue-600 cursor-pointer'
                    : 'text-gray-500 cursor-default',
              ]"
              @click="item.href ? null : handleClick(item, index)"
            >
              {{ item.label }}
            </component>
          </div>
        </template>
      </li>
    </ol>
  </nav>
</template>

<script setup lang="ts">
// Imports Vue Packages
import { Home, ChevronRight } from 'lucide-vue-next'
import { useRouter } from 'vue-router'

// Interface
interface BreadcrumbItem {
  label: string
  href?: string
  routeName?: string
  routeParams?: Record<string, any>
  onClick?: () => void
}

defineProps<{
  items: BreadcrumbItem[]
}>()

interface Emits {
  (e: 'item-click', item: BreadcrumbItem, index: number): void
}

// Props and Emits
const emit = defineEmits<Emits>()
const router = useRouter()

// Functions
const handleClick = (item: BreadcrumbItem, index: number) => {
  if (item.routeName) {
    router.push({
      name: item.routeName,
      params: item.routeParams || {},
    })
  } else if (item.onClick) {
    item.onClick()
  }
  emit('item-click', item, index)
}
</script>
